module.exports = __webpack_public_path__ + "img/cheeks_and_tzone.c1a8861d.svg";